import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import GedFileRepository from '@/shared/http/repositories/business/gedfile'
import GedFolderRepository from '@/shared/http/repositories/business/gedfolder'
import GedTagRepository from '@/shared/http/repositories/business/gedtag'
import GedFolderChecklistTypeRepository from '@/shared/http/repositories/business/gedfolderchecklisttype'
import Tools from '@/components/tools/Tools'
import AccountMixin from '@/store/module/account/mixin'
import FolderPermission from '@/shared/utils/folderPermission'
import EditFileForm from './doccontent-form'
import EditFileModel from '@/shared/models/business/gedfilemodel'
import Roles from '@/shared/utils/roles'
import DocMixin from '../../mixins/DocMixin'
import VuePdfApp from 'vue-pdf-app'
import 'vue-pdf-app/dist/icons/main.css'
import FolderHistory from './folderhistory.vue'
import FileHistory from './filehistory.vue'

const Tabs = {
  EDIT: 0,
  HISTORY: 1
}

export default {
  name: 'doccontent',
  mixins: [DocMixin, ActionsForm, AccountMixin],
  props: {
    isSelectionOnly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VuePdfApp,
    FolderHistory,
    FileHistory
  },
  created () {
    this.onLoadAllTypes()
    this.onLoadAllSubjects()
    this.onLoadAllTags()
  },
  data () {
    return {
      objList: [],
      folder: null,
      sendingFiles: [],
      isDragging: false,
      isUndeleting: false,
      editingFile: null,
      showHistory: false,
      showMiniatures: false,
      folderPermission: FolderPermission,
      form: EditFileForm,
      data: EditFileModel,
      selectedTags: [],
      roles: Roles,
      tabIndex: Tabs.EDIT,
      folderChecklistTypes: [],
      uploadType: {
        CREATE: 1,
        UPDATE: 2
      },
      pdfConfig: {
        toolbar: {
          // toolbarViewerLeft: {
          //   findbar: true,
          //   previous: true,
          //   next: true,
          //   pageNumber: true
          // },
          toolbarViewerRight: {
            presentationMode: false,
            openFile: false,
            // print: true,
            download: false,
            viewBookmark: false
          },
          toolbarViewerMiddle: {
            zoomOut: true,
            zoomIn: true,
            scaleSelectContainer: true
          }
        },
        secondaryToolbar: {
          secondaryPresentationMode: false,
          secondaryOpenFile: false,
          secondaryPrint: false,
          secondaryDownload: false,
          secondaryViewBookmark: false,
          // firstPage: true,
          // lastPage: true,
          pageRotateCw: true,
          pageRotateCcw: true,
          cursorSelectTool: false,
          cursorHandTool: false,
          scrollVertical: false,
          scrollHorizontal: false,
          scrollWrapped: false,
          spreadNone: false,
          spreadOdd: false,
          spreadEven: false,
          documentProperties: false
        }
      },
      previewPDF: null,
      previewIMG: null
    }
  },
  computed: {
    selectedCount () {
      return this.objList.filter(f => f.checked).length
    }
  },
  methods: {
    checkChanged (obj) {
      this.$emit('on-selected', obj)
    },
    getTagName (gedArquivoTag) {
      const name = this.form.gedTagID.options.filter(op => op.value === gedArquivoTag.gedTagID).map(op => op.text)[0]
      return name
    },
    classFormat (format) {
      return {
        'fas fa-file-pdf text-danger': format === 'PDF',
        'fas fa-file-word text-primary': format === 'DOC',
        'fas fa-file-excel text-success': format === 'XLS',
        'fas fa-file-powerpoint': format === 'PPT',
        'fas fa-file-image text-warning': format === 'IMG',
        'fas fa-file-alt text-default': format === 'TXT'
      }
    },
    onLoad (folder) {
      this.load(this.folder)
    },
    load (folder) {
      this.editingFile = null
      this.folder = folder
      this.isDragging = false

      if (folder && folder.id) {
        loading.push()
        GedFileRepository.GetAllPaging(folder.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(response => {
            if (response.data.code > 0) {
              this.onResultGrid(response)
              this.loadImages()
              if (folder.gedChecklistID) {
                GedFolderChecklistTypeRepository.GetAll(folder.id)
                  .then(response => {
                    if (response.data.code > 0) {
                      this.folderChecklistTypes = response.data.data
                      this.objList.push(...response.data.data)
                      this.loadFix()
                    }
                  })
              }
            }
          })
          .catch(err => {
            console.log(err)
            loading.close()
          })
      } else {
        var result = {
          data: {
            code: 200,
            count: 0,
            data: [],
            message: 'The request has succeeded',
            pagingIndex: 1,
            pagingLimit: this.$refs.tableGrid.pagingLimitDefault,
            resultException: null,
            totalPages: 1
          }
        }

        this.onResultGrid(result)
      }
    },
    loadFix () {
      this.objList.forEach(a => {
        if (a.gedChecklistTipo) {
          a.check = this.objList.some(b => b.gedTipo && b.gedTipo.nome === a.gedChecklistTipo.gedTipo.nome)
        }
      })

      this.objList.sort((fileA, fileB) => {
        let nameA = ''
        let nameB = ''

        if (fileA.gedChecklistTipo) {
          if (fileA.status === 0) {
            nameA = 'C' + fileA.ordem.toString().padStart(3, '0')
          } else if (fileA.check) {
            nameA = 'A' + fileA.ordem.toString().padStart(3, '0')
          } else {
            nameA = 'B' + fileA.ordem.toString().padStart(3, '0')
          }
        } else {
          var hasTypeCheckA = this.folderChecklistTypes.filter(f => f.gedChecklistTipo.gedTipoID === fileA.gedTipoID)
          if (hasTypeCheckA.length) {
            nameA = 'A' + hasTypeCheckA[0].ordem.toString().padStart(3, '0') + '@' + fileA.nome
          } else {
            nameA = '@' + fileA.nome
          }
        }

        if (fileB.gedChecklistTipo) {
          if (fileB.status === 0) {
            nameB = 'C' + fileB.ordem.toString().padStart(3, '0')
          } else if (fileB.check) {
            nameB = 'A' + fileB.ordem.toString().padStart(3, '0')
          } else {
            nameB = 'B' + fileB.ordem.toString().padStart(3, '0')
          }
        } else {
          var hasTypeCheckB = this.folderChecklistTypes.filter(f => f.gedChecklistTipo.gedTipoID === fileB.gedTipoID)
          if (hasTypeCheckB.length) {
            nameB = 'A' + hasTypeCheckB[0].ordem.toString().padStart(3, '0') + '@' + fileB.nome
          } else {
            nameB = '@' + fileB.nome
          }
        }

        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0
      })
    },
    selectAll (sel) {
      this.objList.forEach(doc => {
        if (doc.status) {
          this.$set(doc, 'checked', sel)
        }
      })
    },
    onEditFile (file) {
      if (file.status && this.hasFolderPermission(this.folderPermission.WRITE, this.folder)) {
        this.tabIndex = Tabs.EDIT
        this.editingFile = file
        this.selectedTags = file.gedArquivoTags ? file.gedArquivoTags.map(f => {
          return this.form.gedTagID.options.filter(op => op.value === f.gedTagID)[0]
        }) : []

        this.onEdit(file)
        this.$nextTick(() => {
          this.$refs.txtName.focus()
        })
      } else {
        if (file.status) {
          toast.error(this.$lang.Documents.File.LabelNotPermission)
        } else {
          toast.error(this.$lang.Documents.File.LabelDisabled)
        }
      }
    },
    onBackEditFile () {
      this.editingFile = null
      this.showHistory = false
    },
    onUpdate () {
      this.data.gedArquivoTags = this.data.gedArquivoTags.filter(t => {
        return this.selectedTags.some(op => op.value === t.gedTagID)
      })
      const listToAdd = this.selectedTags.filter(op => op.value && !this.data.gedArquivoTags.some(tg => tg.gedTagID === op.value))
      if (listToAdd.length) {
        this.data.gedArquivoTags.push(...listToAdd.map(op => {
          return {
            id: '00000000-0000-0000-0000-000000000000',
            gedArquivoID: this.data.id,
            gedTagID: op.value,
            status: 1
          }
        }))
      }
      const doUpdate = () => {
        let promises = [Promise.resolve()]

        this.selectedTags.filter(op => !op.value).forEach(op => {
          const data = {
            id: '00000000-0000-0000-0000-000000000000',
            nome: op.text,
            status: 1
          }
          promises.push(
            GedTagRepository.Create(data)
              .then(response => {
                if (response.data.code > 0) {
                  this.data.gedArquivoTags.push({
                    id: '00000000-0000-0000-0000-000000000000',
                    gedArquivoID: this.data.id,
                    gedTagID: response.data.data.id,
                    status: 1
                  })
                  this.form.gedTagID.options.push({
                    text: response.data.data.nome,
                    value: response.data.data.id
                  })
                }
              })
          )
        })

        Promise.all(promises)
          .then(() => {
            this.data.status = parseInt(this.data.status)
            GedFileRepository.Update(this.data)
              .then(response => {
                if (response.data.code > 0) {
                  Object.assign(this.editingFile, response.data.data)
                  this.editingFile = null
                  if (this.folder.gedChecklistID) {
                    this.loadFix()
                    this.$emit('fixOpen', this.folder)
                  }
                } else {
                  toast.error(this.$lang.Common.CouldNotSave)
                }
              })
          })
          .catch(err => this.onException(err))
      }

      doUpdate()
      this.showHistory = false
    },
    onUpdateChecklistType (checklist) {
      checklist.status = checklist.status === 0 ? 1 : 0
      GedFolderChecklistTypeRepository.Update(checklist)
        .then(response => {
          if (response.data.code > 0) {
            this.loadFix()
            this.$emit('fixOpen', this.folder)
          }
        })
    },
    onDeleteFile (file) {
      loading.push()
      GedFileRepository.Delete(file.id)
        .then(response => {
          if (response.data.code > 0) {
            this.onLoad()
          } else {
            toast.error(this.$lang.Common.ActionNotTaken)
          }
          loading.close()
        })
        .catch(err => this.onException(err))
    },
    onChangeFile (file) {
      loading.push()
      file.status = file.status === 1 ? 0 : 1
      GedFileRepository.UpdateStatus(file)
        .then(response => {
          if (response.data.code === 0) {
            toast.error(this.$lang.Common.ActionNotTaken)
          }
          loading.close()
        })
        .catch(err => this.onException(err))
    },
    onHistory () {
      this.showHistory = !this.showHistory
      this.$nextTick(() => {
        if (this.showHistory) {
          this.$refs.FolderHistory.load(this.folder)
        }
      })
    },
    loadImages () {
      if (this.showMiniatures) {
        this.objList.forEach(file => {
          if (file.formato === 'IMG' && !file.miniature) {
            GedFileRepository.DownloadById(file.id, {}, { responseType: 'blob' })
              .then(response => {
                if (response.data.code > 0) {
                  this.$set(file, 'miniature', response.data.data)
                }
              })
          }
        })
      }
    },
    onPreviewFile (file) {
      if (file.status) {
        this.previewIMG = null
        this.previewPDF = null
        if (file.formato === 'IMG' && file.miniature) {
          this.previewIMG = file.miniature
          this.$bvModal.show('preview-modal')
        } else if (file.formato === 'PDF' || file.formato === 'IMG') {
          loading.push()
          GedFileRepository.DownloadById(file.id, {}, { responseType: 'blob' })
            .then(response => {
              if (response.data.code > 0) {
                if (file.formato === 'PDF') {
                  this.previewPDF = response.data.data
                }
                if (file.formato === 'IMG') {
                  file.miniature = response.data.data
                  this.previewIMG = response.data.data
                }
                loading.pop()
                this.$bvModal.show('preview-modal')
              }
            })
            .catch(err => {
              this.onException(err)
            })
        }
      } else {
        toast.error(this.$lang.Documents.File.LabelDisabled)
      }
    },
    onDownloadFiles () {
      const list = this.$refs.tableGrid.objList.filter(f => f.checked).map(f => f.id)
      this.downloadFiles(list)
    },
    onDownloadFile (file) {
      if (file) {
        this.downloadFiles([file.id])
      }
    },
    downloadFiles (list) {
      if (list.length) {
        // loading.push()

        const sendingFile = {
          id: Math.floor(Math.random() * 10000),
          nome: 'Download.zip',
          percent: 0,
          loaded: '...'
        }

        this.sendingFiles.push(sendingFile)

        const config = {
          responseType: 'blob',
          sendingFile: sendingFile,
          onDownloadProgress: progressEvent => {
            const loaded = progressEvent.loaded / 1024
            sendingFile.loaded = loaded.toFixed(0) + ' KB'
            sendingFile.percent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            if (progressEvent.loaded === progressEvent.total) {
              this.sendingFiles = this.sendingFiles.filter(f => f.id !== sendingFile.id)
            }
          }
        }

        GedFileRepository.Download(list, config)
          .then(response => {
            if (response.status === 200) {
              // const byte = encodeURI(response.data.data)
              const blob = new Blob([response.data], {type: 'applicaiton/zip'})
              const link = document.createElement('a')
              // link.href = `data:application/zip;base64,${byte}`
              link.href = window.URL.createObjectURL(blob)
              link.download = 'Download.zip'
              link.click()
              URL.revokeObjectURL(link.href)
            } else {
              toast.error(this.$lang.Common.ActionNotTaken)
            }
            // loading.close()
          })
          .catch(err => {
            this.sendingFiles = this.sendingFiles.filter(f => f.id !== err.config.sendingFile.id)
            this.onException(err)
          })
      }
    },
    async onDropFiles (event) {
      event.preventDefault()
      event.stopPropagation()

      if (this.folder) {
        const items = event.dataTransfer.items

        for (let i = 0; i < items.length; i++) {
          const item = items[i]
          let entry = item.webkitGetAsEntry()

          if (entry.isFile) {
            entry.file(file => {
              file.fullPath = this.folder.pathName + entry.fullPath
              this.uploadFiles([file], this.folder)
            }, err => {
              console.log(err)
              this.onException(err)
            })
          } else {
            const folderSameName = this.folder.gedPastas ? this.folder.gedPastas.filter(f => f.nome === entry.name) : []
            if (folderSameName.length) {
              if (await this.showConfirmBox(folderSameName[0].nome)) {
                this.getFileSystemEntryPatchMode(entry, folderSameName[0])
              } else {
                continue
              }
            } else {
              this.createFolder(this.folder, entry.name)
                .then(response => {
                  this.getFileSystemEntry(entry, response)
                })
            }
          }
        }

        this.isDragging = false
      }
    },
    getFileSystemEntryPatchMode (entry, folder) {
      const self = this
      const reader = entry.createReader()
      function readEntries () {
        reader.readEntries((entries) => {
          if (entries.length === 0) return
          entries.forEach(ientry => {
            if (ientry.isFile) {
              ientry.file(ifile => {
                ifile.fullPath = self.folder.pathName + ientry.fullPath
                self.putFile(ifile, folder)
              }, err => {
                console.log(err)
                self.onException(err)
              })
            } else if (ientry.isDirectory) {
              GedFolderRepository.GetAllByFolder(folder.id)
                .then(response => {
                  const rs = response.data.data
                  const folderSameName = rs ? rs.filter(f => f.nome === ientry.name) : []
                  if (folderSameName.length === 0) {
                    self.createFolder(folder, ientry.name)
                      .then(response => {
                        self.getFileSystemEntry(ientry, response)
                      })
                  } else {
                    self.getFileSystemEntryPatchMode(ientry, folderSameName[0])
                  }
                })
            }
          })
          readEntries()
        }, error => this.onException(error))
      }
      readEntries()
    },
    getFileSystemEntry (entry, folder) {
      const self = this
      const reader = entry.createReader()
      function readEntries () {
        reader.readEntries((entries) => {
          if (!entries.length) {
          } else {
            entries.forEach(ientry => {
              if (ientry.isFile) {
                ientry.file(ifile => {
                  ifile.fullPath = self.folder.pathName + entry.fullPath
                  self.uploadFiles([ifile], folder)
                }, err => {
                  console.log(err)
                  self.onException(err)
                })
              } else if (ientry.isDirectory) {
                self.createFolder(folder, ientry.name)
                  .then(response => {
                    self.getFileSystemEntry(ientry, response)
                  })
              }
            })
            readEntries()
          }
        }, error => this.onException(error))
      }
      readEntries()
    },
    createFolder (folder, name) {
      return new Promise(resolve => {
        const data = {
          id: '00000000-0000-0000-0000-000000000000',
          nome: name,
          gedPastaPaiID: folder.id,
          gedTipoID: folder.gedTipoID,
          gedAssuntoID: folder.gedAssuntoID,
          empresaID: this.CompanySelected,
          seguranca: folder.seguranca,
          status: 1,
          gedPastaGrupos: folder.gedPastaGrupos.map(f => {
            f.gedPastaID = '00000000-0000-0000-0000-000000000000'
            f.id = '00000000-0000-0000-0000-000000000000'
            return f
          }),
          gedPastaContas: folder.gedPastaContas.map(f => {
            f.gedPastaID = '00000000-0000-0000-0000-000000000000'
            f.id = '00000000-0000-0000-0000-000000000000'
            return f
          }),
          gedPastaTags: folder.gedPastaTags ? folder.gedPastaTags.map(f => {
            f.gedPastaID = '00000000-0000-0000-0000-000000000000'
            f.id = '00000000-0000-0000-0000-000000000000'
            return f
          }) : [],
          gedPastas: []
        }

        GedFolderRepository.Create(data)
          .then(response => {
            if (response.data.code > 0) {
              folder.gedPastas = folder.gedPastas || []
              folder.gedPastas.push(response.data.data)
              resolve(response.data.data)
            } else {
              toast.error(this.$lang.Common.ActionNotTaken)
            }
          })
      })
    },
    onUploadFiles (event) {
      if (this.folder) {
        if (event.target.files) {
          this.uploadFiles(event.target.files, this.folder)
          this.$refs.UploadFile.value = ''
        }
      }
    },
    uploadFiles (files, folder) {
      for (const file of files) {
        const xls = /\.xlsx?$/i
        const ppt = /\.pptx?$/i
        const doc = /\.docx?$/i
        const pdf = /\.pdf?$/i
        const img = /\.jpg|\.jpeg|\.gif|\.png$/i

        const data = {
          id: '00000000-0000-0000-0000-000000000000',
          nome: file.name,
          gedPastaID: folder.id,
          gedTipoID: folder.gedTipoID,
          gedAssuntoID: folder.gedAssuntoID,
          gedArquivoTags: folder.gedPastaTags ? folder.gedPastaTags.map(f => {
            return {
              gedArquivoID: '00000000-0000-0000-0000-000000000000',
              gedTagID: f.gedTagID,
              status: 1
            }
          }) : [],
          formato: doc.test(file.name) ? 'DOC'
            : xls.test(file.name) ? 'XLS'
              : ppt.test(file.name) ? 'PPT'
                : pdf.test(file.name) ? 'PDF'
                  : img.test(file.name) ? 'IMG'
                    : 'TXT',
          tamanho: file.size,
          versao: 1,
          status: 1
        }

        const fileSameName = this.objList.filter(f => f.nome === data.nome)
        if (fileSameName.length > 0) {
          const dataDb = fileSameName[0]

          data.id = dataDb.id
          data.versao = ++dataDb.versao

          GedFileRepository.Update(data)
            .then(response => {
              if (response.data.code > 0) {
                this.uploadFile(file, response.data.data.id, this.uploadType.UPDATE)
                this.onLoad()
              } else {
                toast.error(this.$lang.Common.ActionNotTaken)
              }
            })
            .catch(err => {
              this.onException(err)
            })
        } else {
          GedFileRepository.Create(data)
            .then(response => {
              if (response.data.code > 0) {
                this.uploadFile(file, response.data.data.id, this.uploadType.CREATE)
                if (this.folder.id === folder.id) {
                  this.objList.push(response.data.data)
                  this.$refs.tableGrid.count = this.$refs.tableGrid.count + 1
                  this.$refs.tableGrid.total = this.$refs.tableGrid.total + 1
                }
              } else {
                toast.error(this.$lang.Common.ActionNotTaken)
              }
            })
            .catch(err => {
              this.onException(err)
            })
        }
      }
    },
    uploadFile (file, gedFileID, type) {
      const sendingFile = {
        id: gedFileID,
        file: file,
        nome: file.name,
        percent: 0,
        path: file.fullPath,
        erro: false,
        tipoUpload: type
      }

      this.sendingFiles.push(sendingFile)

      const config = {
        sendingFile: sendingFile,
        onUploadProgress: progressEvent => {
          sendingFile.percent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          // if (progressEvent.loaded === progressEvent.total) {
          //   this.sendingFiles = this.sendingFiles.filter(f => f.id !== sendingFile.id)
          // }
        }
      }

      const formData = new FormData()
      formData.append('file', file)
      GedFileRepository.Upload(this.CompanySelected, gedFileID, formData, config)
        .then(response => {
          console.log(response)
          if (response.status === 200) {
            this.sendingFiles = this.sendingFiles.filter(f => f.id !== response.config.sendingFile.id)
          }
          // if (progressEvent.loaded === progressEvent.total) {
          //   this.sendingFiles = this.sendingFiles.filter(f => f.id !== sendingFile.id)
          // }
        })
        .catch(err => {
          // this.sendingFiles = this.sendingFiles.filter(f => f.id !== sendingFile.id)
          this.onException(err)
          console.log(err)
          const sf = this.sendingFiles.filter(s => s.id === err.config.sendingFile.id)[0]
          sf.erro = true
          if (sf.tipoUpload === this.uploadType.CREATE) {
            GedFileRepository.Delete(err.config.sendingFile.id)
              .then(() => {
                this.onLoad()
              })
          }
        })
    },
    removeSending (sendingFile) {
      this.sendingFiles = this.sendingFiles.filter(s => s.id !== sendingFile.id)
    },
    retrySending (sendingFile) {
      GedFileRepository.Get(sendingFile.id)
        .then(response => {
          if (response.data.code > 0) {
            response.data.data.status = 1
            GedFileRepository.Update(response.data.data)
              .then(response => {
                if (response.data.code > 0) {
                  this.removeSending(sendingFile)
                  this.uploadFile(sendingFile.file, response.data.data.id, sendingFile.tipoUpload)
                  this.onLoad()
                } else {
                  toast.error(this.$lang.Common.ActionNotTaken)
                }
              })
              .catch(err => {
                this.onException(err)
              })
          } else {
            toast.error(this.$lang.Common.ActionNotTaken)
          }
        })
        .catch(err => {
          this.onException(err)
        })
    },
    putFile (file, folder) {
      let extension = 'TXT'
      extension = /\.xlsx?$/i.test(file.name) ? 'XLS' : extension
      extension = /\.pptx?$/i.test(file.name) ? 'PPT' : extension
      extension = /\.docx?$/i.test(file.name) ? 'DOC' : extension
      extension = /\.pdf?$/i.test(file.name) ? 'PDF' : extension
      extension = /\.jpg|\.jpeg|\.gif|\.png$/i.test(file.name) ? 'IMG' : extension

      const data = {
        id: '00000000-0000-0000-0000-000000000000',
        nome: file.name,
        gedPastaID: folder.id,
        gedTipoID: folder.gedTipoID,
        gedAssuntoID: folder.gedAssuntoID,
        gedArquivoTags: folder.gedPastaTags ? folder.gedPastaTags.map(f => {
          return {
            gedArquivoID: '00000000-0000-0000-0000-000000000000',
            gedTagID: f.gedTagID,
            status: 1
          }
        }) : [],
        formato: extension,
        tamanho: file.size,
        versao: 1,
        status: 1
      }

      GedFileRepository.GetAllByFolder(folder.id)
        .then(response => {
          const rs = response.data.data
          const fileSameName = rs ? rs.filter(f => f.nome === data.nome) : []
          if (fileSameName.length > 0) {
            const dataDb = fileSameName[0]

            data.id = dataDb.id
            data.versao = ++dataDb.versao

            GedFileRepository.Update(data)
              .then(response => {
                if (response.data.code > 0) {
                  this.uploadFile(file, response.data.data.id, this.uploadType.UPDATE)
                  this.onLoad()
                } else {
                  toast.error(this.$lang.Common.ActionNotTaken)
                }
              })
              .catch(err => {
                this.onException(err)
              })
          } else {
            GedFileRepository.Create(data)
              .then(response => {
                if (response.data.code > 0) {
                  this.uploadFile(file, response.data.data.id, this.uploadType.CREATE)
                  if (this.folder.id === folder.id) {
                    this.objList.push(response.data.data)
                    this.$refs.tableGrid.count = this.$refs.tableGrid.count + 1
                    this.$refs.tableGrid.total = this.$refs.tableGrid.total + 1
                  }
                } else {
                  toast.error(this.$lang.Common.ActionNotTaken)
                }
              })
              .catch(err => {
                this.onException(err)
              })
          }
        })
    },
    formatSize (bytes) {
      return Tools.FormatSize(bytes)
    },
    setData (folder, response) {
      this.$refs.tableGrid.LoadAllByData(response)
      this.objList = response ? response.data.data : []
      this.folder = folder
    },
    onDragOver (event) {
      event.preventDefault()
      event.stopPropagation()
      event.dataTransfer.dropEffect = 'none'
      event.dataTransfer.effectAllowed = 'none'

      if (this.hasFolderPermission(this.folderPermission.WRITE, this.folder)) {
        if (this.folder && !this.isUndeleting && !this.editingFile && !this.showHistory) {
          event.dataTransfer.dropEffect = 'copy'
          event.dataTransfer.effectAllowed = 'copy'
        }
      }
    },
    onDragEnter (event) {
      console.log('entrou')
      event.preventDefault()
      event.stopPropagation()
      event.dataTransfer.dropEffect = 'none'
      event.dataTransfer.effectAllowed = 'none'

      if (this.hasFolderPermission(this.folderPermission.WRITE, this.folder)) {
        if (this.folder && !this.isUndeleting && !this.editingFile && !this.showHistory) {
          event.dataTransfer.dropEffect = 'copy'
          event.dataTransfer.effectAllowed = 'copy'
          this.isDragging = true
        }
      }
    },
    onDragLeave (event) {
      event.preventDefault()
      event.stopPropagation()

      this.isDragging = false
    },
    async showConfirmBox (folderName) {
      let result = false
      await this.$bvModal.msgBoxConfirm(
        this.$lang.Documents.Folder.ReceiverFolder + ` "${folderName}" ` +
        this.$lang.Documents.Folder.SubstituitionMessage + '.\r\n' +
        this.$lang.Documents.Folder.SubstituitionQuestion, {
          title: this.$lang.Documents.Folder.SubstituitionTitle,
          size: 'md',
          buttonSize: 'sm',
          okTitle: this.$lang.Common.Yes,
          cancelTitle: this.$lang.Common.Cancel,
          hideHeaderClose: true,
          centered: true
        })
        .then(value => { result = value })
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/content/doccontent.js